import Route from 'cio/routes/base';
import { Crumb } from 'cio/services/crumbs';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import ObjectTypeModel from 'cio/models/object-type';
import Transition from '@ember/routing/-private/transition';
import { redirectIfNoPermission } from 'cio/utils/route-access';

export default class ObjectsEditRoute extends Route {
  @service store!: DS.Store;

  crumb(): Crumb {
    return {
      name: 'Edit Object',
      path: this.routeName,
    };
  }

  model({ object_type }: Record<string, any>): ObjectTypeModel | undefined {
    return this.store.peekAll('object-type').find((objectType) => objectType.id === object_type);
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    return redirectIfNoPermission(this, 'journeys/object_types/edit', transition);
  }
}
